import {Component, OnInit, ɵɵtrustConstantResourceUrl} from '@angular/core';
import {NavController, ModalController} from '@ionic/angular';
import {EditTeamPage} from '../../edit-team/edit-team.page';
import {ActivatedRoute} from '@angular/router';
import {Router} from '@angular/router';
import {DataStore} from '@aws-amplify/datastore';
import {Team, User} from '../../../models';
import {BonusesComponent} from '../../components/lists/bonuses/bonuses.component';

@Component({
    selector: 'app-team',
    templateUrl: './team.page.html',
    styleUrls: ['./team.page.scss'],
})
export class TeamPage implements OnInit {
    teamId;
    currentTeam;
    teammates: User[] = [];
    membersForBonus = [];

    currentPanel = 'overview';

    project = 'overview';
    period = 'mese';
    bonusByPeriod = 2500;
    teamTotSales = 50000;
    teamCurrentFeeLevel = 1.5;
    teamCurrentSalesLevel = 15000;
    showBonusMembersPanel = false;
    showTotalRevenuePanel = true;
    showCompanyBonusPanel = false;
    showDirectorBonusPanel: boolean = false;

    constructor(
        private route: ActivatedRoute,
        public router: Router,
        private navController: NavController,
        private modalController: ModalController,
    ) {
    }

    async ngOnInit() {
        await this.route.params.subscribe(params => {
            this.teamId = params['teamId'];
        });

        this.refreshTeam();
    }

    ionViewDidEnter() {
        // make sure the newly styled content scrolls when needed
        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length-1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
    }

    async editTeam() {
        const modal = await this.modalController.create({
            component: EditTeamPage,
            componentProps: {teamId: this.currentTeam.id},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {
            this.refreshTeam();
        });
    }

    private async refreshTeam() {
        this.currentTeam = await DataStore.query(Team, this.teamId);
        // this.teammates = await DataStore.query(User, u => u.teamID("eq", this.currentTeam.id));
        this.teammates = (await DataStore.query(User)).slice(0, 6);
        this.membersForBonus = await (await DataStore.query(User)).slice(0, 6);
        
    }

    openUserProfile(userId) {
        this.router.navigate(['/profile', userId]);
    }

    back() {
        this.navController.back();
    }

    openPage(s: string) {
        
    }
}
